import { AiProductInsightSchema_ } from "@redotech/redo-model/agents/returns-agents/product-insights";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getProductInsights = {
  name: "getProductInsights" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: AiProductInsightSchema_.extend({ _id: zExt.objectId() }).optional(),
};
